<template>
    <div>
        <table class="body-2 mb-3">
            <!--<colgroup>
                <col width="100%" />
                <col width="0%" />
                <col width="0%" />
                <col width="0%" />
                <col width="0%" />
                <col width="0%" />
                <col width="0%" />
                <col width="0%" />
            </colgroup>-->
            <tr>
                <td colspan="8">
                    <span class="grey--text text--darken-1">{{label}}</span>
                    <p :class="dataObject.getCSSColor(type, 'tabPkt',
                                ['subtitle-1 font-weight-bold text-truncate'])">
                        {{dataObject[type].vereinsNr}}
                        <span v-if="$vuetify.breakpoint.smAndUp"> / </span><br v-else>
                        {{dataObject[type].teamName}}
                    </p>
                </td>
            </tr>
            <tr class="text-center font-weight-bold">
                <td class="text-left" style="width: 160px">Pass/Name</td>
                <td class="text-center check">ÖR</td>
                <td class="text-center check pr-3">BR</td>
                <td class="pr-1">FW</td>
                <td v-if="isCup"></td>
                <td>1.D</td>
                <td>2.D</td>
                <td>3.D</td>
                <td>4.D</td>
                <td v-if="!isCup"><div style="width: 46px">Kegel</div>SP</td>
                <td><div v-if="!isCup" style="width: 40px" class="ml-1">MP</div>
                    <div v-else style="width: 40px" class="ml-1">GES</div></td>
            </tr>
            <tr v-for="i in numberOfSpieler" :key="i" style="vertical-align: top">
                <td class="spieler">
                    {{dataObject.partien[i][type].spieler.name.substr(8)}}<br>
                    <span class="caption grey--text text--darken-1">
                        {{dataObject.partien[i][type].spieler.name.substr(0,6)}}
                        <span class="ml-1 ">{{dataObject.getAltersklasse(dataObject.partien[i][type].spieler)}}</span>
                    </span>
                </td>
                <td class="text-center">
                    <v-checkbox v-model="dataObject.partien[i][type].oeR"
                                hide-details class="ma-0 pa-0 ml-2"></v-checkbox>
                </td>
                <td class="text-center">
                    <v-checkbox v-model="dataObject.partien[i][type].bR"
                                hide-details class="ma-0 pa-0 ml-2 pr-3"></v-checkbox>
                </td>
                <td>
                    <input @input="scheduleSaveWithCalc($event, i)"
                           onclick="javascript: this.select(); this.setSelectionRange(0, this.value.length);"
                           class="numberInput mr-1 borderRight" type="text"
                           maxlength="3" pattern="[0-9]{3}"
                           v-model="dataObject.partien[i][type].fehlwuerfe"/><!--@change="calculate($event, i)"-->
                    <div class="satzpunkt white"></div>
                </td>
                <td v-if="isCup" class="text-center px-1">
                    <div class="mt-1">Volle</div><div style="margin-top: 9px">Abr.</div>
                </td>
                <td v-for="j in 4" :key="j" style="position: relative">
                    <input @input="scheduleSaveWithCalc($event, i, 'd'+j, 'input')"
                           onclick="javascript: this.select(); this.setSelectionRange(0, this.value.length);"
                           :class="[{'borderRight': j===4}, 'numberInput']"
                           type="text" maxlength="3" pattern="[0-9]{3}"
                           v-model="dataObject.partien[i][type].input['d'+j]"/> <!--@change="calculate($event, i, 'd'+j)"-->
                    <div :class="[{'borderRight': j===4}, 'satzpunkt mb-2']"
                        v-if="dataObject.partien[i][type].kegel && !isCup">
                        {{dataObject.partien[i][type]['sp'+j]}}
                    </div>
                    <input v-else-if="isCup" @input="scheduleSaveWithCalc($event, i, 'ar'+j, 'inputAr')"
                           onclick="javascript: this.select(); this.setSelectionRange(0, this.value.length);"
                           :class="[{'borderRight': j===4}, 'numberInput mb-1']" style="margin-top: -1px"
                           type="text" maxlength="3" pattern="[0-9]{3}"
                           v-model="dataObject.partien[i][type].inputAr['ar'+j]"/>
                </td>
                <td v-if="!isCup">
                    <div v-if="dataObject.partien[i][type].kegel">
                        <div class="result resultPins">{{dataObject.partien[i][type].kegel}}</div>
                        <div class="result resultSP mb-2">{{dataObject.partien[i][type].sp}}</div>
                    </div>
                <td>
                    <div v-if="dataObject.partien[i][type].kegel"
                         class="result resultMP mb-2 ml-1">{{dataObject.partien[i][type].kegel}}</div>
                </td>
            </tr>
        </table>
        <v-checkbox v-model="dataObject[type].result.bR"
                    hide-details class="d-inline-block mr-3 my-0">
            <template v-slot:label>
                <span class="body-2 black--text">Mannschaftsbahnrekord</span>
            </template>
        </v-checkbox>
        <v-checkbox v-model="dataObject[type].result.mR"
                    hide-details class="d-inline-block mr-3 my-0">
            <template v-slot:label>
                <span class="body-2 black--text">Mannschaftsrekord</span>
            </template>
        </v-checkbox>
        <v-checkbox v-model="dataObject[type].result.oeR"
                    hide-details class="d-inline-block my-0">
            <template v-slot:label>
                <span class="body-2 black--text">Österr. Rekord</span>
            </template>
        </v-checkbox>
        <table class="body-2 mt-5">
            <tr class="font-weight-bold">
                <td colspan="2" class="pb-3">Ersatzspieler/innen</td>
            </tr>
            <tr v-for="i in dataObject.getNrOfErsatzspielerDefined(type)" :key="i"
                style="vertical-align: top">
                <td>
                    {{dataObject[type].ersatzSpieler[i].name.substr(8)}}<br>
                    <span class="caption grey--text text--darken-1">
                        {{dataObject[type].ersatzSpieler[i].name.substr(0,6)}}
                        <span class="ml-1 ">{{dataObject.getAltersklasse(dataObject[type].ersatzSpieler[i])}}</span>
                    </span>
                </td>
                <td style="width: 350px">
                    <v-autocomplete v-if="dataObject[type].ersatzSpieler[i].eintauschVorFuer!==undefined"
                                    v-model="dataObject[type].ersatzSpieler[i].eintauschVorFuer"
                                    @input="scheduleSave()"
                                    @change="resetEintauschFuer(dataObject[type].ersatzSpieler[i])"
                                    label="Eintausch vor Einspielzeit für Spieler/in" clearable
                                    item-value="id" item-text="name" class="body-2 mr-3 mb-2"
                                    no-data-text="keine Daten gefunden" style="width: 302px"
                                    :items="dataObject.getSpielerListe(type)" outlined dense hide-details>
                    </v-autocomplete>
                    <v-text-field v-model="dataObject[type].ersatzSpieler[i].abWurf"
                                  @input="scheduleSave()"
                                  onclick="javascript: this.select();"
                                  @change="resetEintauschVorFuer(dataObject[type].ersatzSpieler[i])"
                                  outlined dense label="ab Wurf" class="body-2 mr-3 mb-3 d-inline-block"
                                  hide-details type="number" style="width: 80px"></v-text-field>
                    <v-autocomplete v-model="dataObject[type].ersatzSpieler[i].eintauschFuer"
                                    @change="resetEintauschVorFuer(dataObject[type].ersatzSpieler[i])"
                                    label="für Spieler/in" clearable @input="scheduleSave()"
                                    item-value="id" item-text="name" class="body-2 mr-3 mb-3 d-inline-block"
                                    no-data-text="keine Daten gefunden" style="width: 210px"
                                    :items="dataObject.getSpielerListe(type)" outlined dense hide-details>
                    </v-autocomplete>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "spiel-bericht-edit-ergebnis-team",
        props: ['dataObject', 'rules', 'type'],
        computed: {
            isCup(){ return this.dataObject.saison.isCup},
            label(){ return this.type === 'heim' ? 'Heim' : 'Gast'; },
            numberOfSpieler() { return Object.keys(this.dataObject.partien).length; }
        },
        data: () => ({
            calcTimeout: null,
        }),
        methods: {
            calculate(evt, i, dg, fieldName){
                if ( !evt.target.value || isNaN(evt.target.value) ) {
                    if ( dg ) {
                        this.dataObject.partien[i][this.type][fieldName][dg] = 0;
                    } else {
                        this.dataObject.partien[i][this.type].fehlwuerfe = 0;
                    }
                }
                this.dataObject.calculate();
            },
            /*verify(evt, i){
                if ( !evt.target.value || isNaN(evt.target.value) ) {
                    this.dataObject.partien[i][this.type].fehlwuerfe = 0;
                }
            },*/
            resetEintauschFuer(ersatzSpieler) {
                ersatzSpieler.eintauschFuer = '';
                ersatzSpieler.abWurf = 0;
            },
            resetEintauschVorFuer(ersatzSpieler) {
                if ( ersatzSpieler.eintauschVorFuer !== undefined ) {
                    ersatzSpieler.eintauschVorFuer = '';
                }
            },
            scheduleSaveWithCalc(evt, i, dg, fieldName){
                this.calculate(evt, i, dg, fieldName);
                this.$emit('scheduleSave');
            },
            scheduleSave(){
                this.dataObject.calculate();
                this.$emit('scheduleSave');
            }
        },
    }
</script>

<style scoped>
    .v-text-field >>> label {
        font-size: 1em;
    }
    input:checked {
        background-color: green;
    }
    .numberInput{ width: 46px; text-align: center;}
    .satzpunkt{ width: 46px; text-align: center; background-color: #eee;
                height: 20px; border-left: solid 1px grey; border-bottom: solid 1px grey; }
    .check {min-width: 36px;  /*word-wrap: break-word;*/}
    .spieler {
        padding-top: 4px;
        white-space: nowrap; text-overflow:ellipsis; overflow: hidden;
        width: 100%; max-width: 0;
    }
    .result { background-color: #eee; }
    .resultPins { border-right: solid 1px grey; border-top: solid 1px grey; height: 27px; text-align: center;
                  padding-top: 3px; width: 46px}
    .resultSP { border-right: solid 1px grey; border-top: solid 1px grey;; border-bottom: solid 1px grey;
                height: 21px; text-align: center }
    .resultMP { border: solid 1px grey; height: 48px; text-align: center;
                    padding-top: 12px; width: 40px; font-size: 16px}
    input {
        padding: 3px 8px;
        border-left: 1px solid grey;
        border-top: 1px solid grey;
        border-bottom: 1px solid grey;
        box-sizing: border-box;
    }
    .borderRight { border-right: 1px solid grey}
    .borderLeft { border-left: 1px solid grey}
    table {width: 100%; border-spacing: 0; table-layout: auto }
    /*table, td, tr {word-wrap: break-word;}*/
</style>